/**
 * Valid study report routes
 */
const VALID_ROUTES = [
  "study-review",
  "study-select",
  "reports/overview",
  "reports/emotion/overview",
  "reports/memory/overview",
  "reports/attention/overview",
  "reports/in-depth",
] as const;

/**
 * Default route to use when a study route is invalid
 */
const DEFAULT_ROUTE = "reports/overview";

/**
 * Validates and sanitizes a study route.
 * Returns the route if valid, otherwise returns the default route.
 * This handles legacy routes that no longer exist (e.g., attention/clarity, attention/visibility, attention/digestibility)
 *
 * @param route - The study route to validate
 * @returns A valid study route
 */
export const sanitizeStudyRoute = (route: string): string => {
  // Check if the route is valid
  if (VALID_ROUTES.includes(route as (typeof VALID_ROUTES)[number])) {
    return route;
  }

  // Handle legacy attention sub-routes by redirecting to attention overview
  if (route.startsWith("reports/attention/")) {
    return "reports/attention/overview";
  }

  // For any other invalid routes, use the default
  return DEFAULT_ROUTE;
};
